/**
 * DPA Configuration
 * Current version of the Data Processing Agreement
 * Update this when the DPA is modified
 */
export const DPA_CONFIG = {
  currentVersion: "1.0",
  // Add version history for tracking changes
  versions: {
    "1.0": {
      effectiveDate: "2024-01-01", // Update with actual date
      changes: "Initial DPA version",
    },
  },
};

/**
 * Get the current DPA version
 */
export const getCurrentDpaVersion = () => DPA_CONFIG.currentVersion;

/**
 * Check if a version is the current version
 */
export const isCurrentVersion = (version) => {
  return version === DPA_CONFIG.currentVersion;
};

